import { baseUrl } from '../http'
import axios from 'axios'
import { dateLocale, serverDateLocale } from '../../utils'
import moment from "moment";

let personUrl = `${baseUrl}/person`

let cancel;
let CancelToken = axios.CancelToken;

export const personApi = {
  create(personModel) {

    var creationData = {};
    for (let key in personModel) {
      if (!!personModel[key]) creationData[key] = personModel[key]
    }

    ["identityCardCreationDate", "identityCardExpirationDate", "passportCreationDate", "passportExpirationDate"].forEach(k => {
      if (!!creationData[k]) creationData[k] = moment(creationData[k], dateLocale).format(serverDateLocale);
    });

    return axios.put(`${personUrl}/create`, creationData)
      .then(res => {
        if (res.data.success) return res.data.person;
        return Promise.reject("Cannot create person");
      })
      .catch(e => console.log(e));
  },

  fuzzy(containing) {
    if (cancel != undefined) {
      cancel();
    }
    return axios.get(`${personUrl}/fuzzy?query=${containing}`, {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      })
    })
      .then(resp => {
        if (!resp.data.success) return Promise.reject("Cannot search");
        return resp.data.people;
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          console.log("Previous request canceled", err.message);
        } else {
          throw "Getting SuggestedPeople failed!";
        }
      });
  },

  getPersonById(personId) {
    return axios.get(`${personUrl}/${personId}`)
      .then(resp => {
        if (!resp.data.success) return Promise.reject("Cannot get person");
        return resp.data.person;
      })
  },

  update(personId, attributeName, attributeValue) {

    ["identityCardCreationDate", "identityCardExpirationDate", "passportCreationDate", "passportExpirationDate"].forEach(k => {
      if(k == attributeName) attributeValue = moment(attributeValue,dateLocale).format(serverDateLocale);
    });

    return axios
      .post(`${personUrl}/${personId}`, {
        attribute: attributeName,
        value: attributeValue
      })
      .then(res=>{
        if(res.data.success == false) return Promise.reject("cannot make changes");
        return res;
      });
  }

}

function parsePagination(pagination) {
  if (pagination === undefined || pagination == null) {
    return ""
  }
  return `?items=${pagination.perPage}&page=${pagination.currentPage - 1}`
}
